import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

/** Some tool replies contain double-escaped line breaks. Leave code samples literal. */
export function advisorMarkdown(value: string): string {
  return value.split(/(```[\s\S]*?```|`[^`\n]*`)/g)
    .map((part, index) => index % 2 ? part : part.replace(/\\r\\n|\\n|\\r/g, '\n'))
    .join('');
}

export function AdvisorMessage({ content, className = '' }: { content: string; className?: string }) {
  return <div className={`vibe-check-markdown ${className}`}>
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={{
      a: ({ children, ...props }) => <a {...props} target="_blank" rel="noopener noreferrer">{children}</a>,
    }}>{advisorMarkdown(content)}</ReactMarkdown>
  </div>;
}
